exports = module.exports = require("../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".btn-extension-effective-form-document {\n  width: 25px;\n  height: 23px;\n  margin-right: 4px;\n}\n", ""]);

